import React from "react";
import { Link } from "react-router-dom";
import scroll from "../images/scroll.gif";
import { useState, useEffect } from "react";
import Form from "./Form";
import DynamicPage from "./meta/DynamicPage";
export default function Specials({ special, NewPrice, PackageName, Price }) {
  const FlashingBadge = () => {
    const [flash, setFlash] = useState(false);

    useEffect(() => {
      // Trigger the flashing animation on component mount
      setFlash(true);

      // Remove the flash class after the animation ends (3 flashes = 1.5s)
      const timer = setTimeout(() => setFlash(false), 3000);

      return () => clearTimeout(timer); // Cleanup on unmount
    }, []);

    return (
      <h3>
        <span className={`badge text-bg-success ${flash ? "flash-badge" : ""}`}>
          Get any 2 STATIC pages FREE
        </span>
      </h3>
    );
  };

  return (
    <>
      {/* <DynamicPage title="Black Friday" /> */}
      <div className="col-md-6 col-lg-4 mb-30 shadow p-3 mb-5 bg-body-tertiary rounded border border-danger">
        <div className="price-item text-center popular">
          <div className="price-top">
            <h4>{PackageName}</h4>
            <div className="badge bg-primary text-white mt-2">{special}</div>
            <br />

            <h2 className="mb-0">
              <sup>R</sup>
              <span
                className="text-danger text-decoration-line-through"
                style={{ fontSize: "19px" }}
              >
                {Price}
              </span>
              <br />
              <span className="text-capitalize">From</span>
              <br />
              <span className="ms-2 text-success">R {NewPrice}</span>
            </h2>
            <FlashingBadge />
          </div>
          <div className="price-content">
            <h2 className="text-light">Includes</h2>
            <ul className="border-bottom mb-30 mt-md-4 pb-3 text-left list-unstyled">
              <li>
                <i className="zmdi zmdi-check mr-2"></i>
                <span className="c-black">Home Page</span>
              </li>
              <li>
                <i className="zmdi zmdi-check mr-2"></i>
                <span className="c-black">Contact Page</span>
              </li>
              <li>
                <i className="zmdi zmdi-check mr-2"></i>
                <span className="c-black">About Page</span>
              </li>
              <li>
                <p className="badge text-bg-success">
                  Get any 2 STATIC pages FREE
                </p>
              </li>

              {/* <li style={{ listStyle: "none", textAlign: "left" }}>
                  <h4 className="">Dont have a Host ?</h4>
                  <ul style={{ position: "relative", right: "120px" }}>
                    <li className="badge bg-danger text-white mt-2">
                      <h3>Black Friday Special:</h3>
                      <h5>FREE hosting for First month</h5>
                    </li>
                  </ul>
                </li> */}
            </ul>
            <Link
              to="/Contact"
              className="btn btn-custom btn btn-outline-dark text-dark bg-light"
            >
              <img src={scroll} width={40} /> Request a quote
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
